export enum WorkingPauseType {
  NON_WORKING_REASON = 0,
  WORKING_REASON = 1
}
